import type { AdminProductionProgress } from "@storyline/shared";

type CostProgressBannerProps = {
	production: AdminProductionProgress;
};

const CostProgressBanner: React.FC<CostProgressBannerProps> = ({ production }) => {
	const terminal = production.completedJobs + production.failedJobs;
	const percent = production.totalJobs === 0 ? 0 : Math.round((terminal / production.totalJobs) * 100);

	return (
		<div className="flex flex-col gap-2 rounded-xl border border-border-soft bg-surface p-4">
			<div className="flex flex-wrap items-center justify-between gap-2 text-sm">
				<span className="text-foreground">
					{terminal}/{production.totalJobs} jobs terminés · {production.processingJobs + production.pendingJobs} en cours
					{production.failedJobs > 0 ? ` · ${production.failedJobs} en échec` : ""}
				</span>
				<span className="font-semibold text-accent-lav">{production.costUsd.toFixed(2)} $ réels</span>
			</div>
			<div className="h-2 w-full overflow-hidden rounded-full bg-glass">
				<div className="h-full rounded-full bg-accent-strong transition-all" style={{ width: `${percent}%` }} />
			</div>
		</div>
	);
};

export default CostProgressBanner;
